import { useRoutes } from "react-router-dom";
// Routes
import Pricing from "./Pricing/Pricing";
import NotFound from "./NotFound/NotFound";
import Contact from "./Contact/Contact";
import Schedule from "./Schedule/Schedule";
import Checkout from "./Checkout/Checkout";
import PaymentSuccess from "./PaymentSuccess/PaymentSuccess";

const Routes = () =>
  useRoutes([
    { path: "/", element: <NotFound /> },
    {
      path: "/pricing",
      element: <Pricing />,
    },
    {
      path: "/contact",
      element: <Contact />,
    },
    {
      path: "/schedule",
      element: <Schedule />,
    },
    {
      path: "/checkout",
      element: <Checkout />,
    },
    {
      path: "/payment-success",
      element: <PaymentSuccess />,
    },
  ]);

export default Routes;
